import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';

import WhatsappDialog from '../../../../components/CommonDialogs/WhatsappDialog.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { DocumentTypes } from '../../../../constants/policies.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import useForm from '../../../../helpers/useForm';
import { useTipification } from '../../../../hooks/useTipification';
import SendEmailValidation from './SendEmail.validations';

interface SendEmailProps {
  documentType: string;
  noBtn?: boolean;
  closeModalFunc?: Function;
  hidden?: boolean;
  // cleanOnClose?: boolean;
}

const sendMailEvents = {
  policy: 'documentacion_poliza_enviada',
  certificate_of_coverage: 'documentacion_certificado_cobertura_enviado',
  mercosur_certificate: 'documentacion_certificado_mercosur_enviado',
  payment_coupon: 'mis_pagos_cupon_enviado',
  payments_per_day: 'documentacion_certificado_pagos_al_dia',
};

const tipificationKeysMapper = {
  policy: 'DOCUMENTATION_SEND_POLICY',
  certificate_of_coverage: 'DOCUMENTATION_SEND_CERTIFICATE_COVERAGE',
  mercosur_certificate: 'DOCUMENTATION_SEND_MERCOSUR_CERTIFICATE',
  payment_coupon: 'DOCUMENTATION_SEND_PAYMENT_COUPON',
  payments_per_day: 'DOCUMENTATION_SEND_CERTIFICATE_PAYMENT_UP_DATE',
};

const SendEmail: React.FC<SendEmailProps> = ({
  documentType,
  noBtn,
  closeModalFunc,
  hidden,
  // cleanOnClose = false,
}) => {
  const {
    policy,
    success,
    errors,
    getPrintableDocument,
    getDownloadPolicy,
    cleanSuccessErrors,
  } = useVehiclesContext();
  const { user } = useAuthDataContext();
  const [open, setOpen] = useState(noBtn ? true : false);
  const [anotherEmail, setAnotherEmail] = useState(false);
  const [open_dialog, setOpenWhatsappDialog] = useState(false);
  const { trackEvent, events } = useTipification();

  const {
    values: { email: shareEmail },
    errors: { email: emailError },
    handleChange,
  } = useForm(() => {}, SendEmailValidation);

  useEffect(() => {
    if (success.send_email) {
      setOpen(true);
    }
  }, [success]);

  useEffect(() => {
    if (errors.send_email) {
      setOpen(true);
    }
  }, [errors]);

  const getSendEmailAnother = () => {
    if (sendMailEvents[documentType]) {
      dataLayerPush(sendMailEvents[documentType], user?.id);
      trackEvent(events[tipificationKeysMapper[documentType]], policy.id);
    }
    getPrintableDocument(
      policy.id,
      DocumentTypes[documentType as any],
      documentType,
      //policy.endorsements[0].id,
      shareEmail
    );
    setAnotherEmail(false);
    close();
  };

  const getSendEmail = () => {
    if (sendMailEvents[documentType]) {
      dataLayerPush(sendMailEvents[documentType], user?.id);
      trackEvent(events[tipificationKeysMapper[documentType]], policy.id);
    }
    getPrintableDocument(
      policy.id,
      DocumentTypes[documentType]
      //policy.endorsements[0].id
    );
    close();
  };

  const close = () => {
    setOpen(false);
    //cleanOnClose && cleanSuccessErrors();
    cleanSuccessErrors();
    closeModalFunc && closeModalFunc();
  };

  const getContent = () => {
    if (anotherEmail) {
      return (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">
              A continuación ingrese el correo electrónico al cual desea enviar
              el documento:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box my={2}>
              <Typography variant="subtitle2">Correo electrónico</Typography>
              <TextField
                size="small"
                onChange={handleChange}
                fullWidth={true}
                error={!!emailError}
                helperText={emailError}
                name="email"
                id="email"
                placeholder="Ingrese el correo electrónico"
                variant="outlined"
              />
            </Box>
          </Grid>
        </Grid>
      );
    } else if (success.send_email) {
      return (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">
              Su documento ha sido enviado exitosamente
            </Typography>
          </Grid>
        </Grid>
      );
    } else if (errors.send_email) {
      return (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">
              Ha ocurrido un error enviando el documento. Por favor intente de
              nuevo.
            </Typography>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container>
          <Grid item xs={12}>
            <Typography>
              ¿Desea enviar el documento a "{user?.email}"?
            </Typography>
          </Grid>
        </Grid>
      );
    }
  };

  const getActions = () => {
    if (anotherEmail) {
      return (
        <Grid container justify="center">
          <Grid item xs={6}>
            <Box mr={2} my={2} textAlign="center">
              <Button
                variant="outlined"
                color="primary"
                onClick={getSendEmailAnother}
                disabled={!!emailError || !shareEmail}
              >
                Enviar
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={2} my={2} textAlign="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setAnotherEmail(false);
                  setOpen(false);
                }}
              >
                Cancelar
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    } else if (success.send_email) {
      return (
        <Grid container justify="center">
          <Grid item xs={6}>
            <Box ml={2} my={2} textAlign="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpen(false);
                  cleanSuccessErrors();
                }}
              >
                Entendido
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    } else if (errors.send_email) {
      return (
        <Grid container justify="center">
          <Grid item xs={6}>
            <Box ml={2} my={2} textAlign="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpen(false);
                  cleanSuccessErrors();
                }}
              >
                Entendido
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container justify="center">
          <Grid item xs={6}>
            <Box mr={1} ml={2} my={2} textAlign="center">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={getSendEmail}
              >
                Enviar
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={1} mr={2} my={2} textAlign="center">
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => setAnotherEmail(true)}
              >
                Enviar a otro email
              </Button>
            </Box>
          </Grid>
        </Grid>
      );
    }
  };

  const [loading, setLoading] = useState(false);

  const [dialogMesagge, setDialogMessage] = useState('');

  const downloadPolicy = (policy_id, number) => {
    setLoading(true);

    getDownloadPolicy(policy_id).then((response) => {
      setLoading(false);

      if (response?.data?.data) {
        const downloadLink = document.createElement('a');
        downloadLink.href = `data:application/pdf;base64,${response.data.data}`; // linkSource;
        downloadLink.download = `poliza_${number}.pdf`; // fileName;
        downloadLink.click();
        trackEvent(events[tipificationKeysMapper[documentType]], policy_id);
      } else {
        setDialogMessage(
          'En este momento no podemos descargar tu póliza. Podés seguir operando vía Whatsapp.'
        );
        setOpenWhatsappDialog(true);
      }
    });
  };

  const validateCompany = (policy) => {
    policy?.provider?.company.toLowerCase() == 'galicia'
      ? downloadPolicy(policy.id, policy.number)
      : setOpen(true);
    // setDialogMessage('En este momento no podemos enviarte la información de tu póliza. Podés seguir operando vía Whatsapp.');
  };

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => close()}
        content={getContent()}
        actions={getActions()}
      ></SharedDialog>

      <WhatsappDialog
        is_open={open_dialog}
        close_dialog={() => setOpenWhatsappDialog(false)}
        message={dialogMesagge}
      />

      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Descargando póliza'}></Loader>
      </Box>

      <Grid container>
        {!noBtn && (
          <Grid item xs={12}>
            <Button
              style={{ display: hidden ? 'none' : '' }}
              variant="contained"
              color="primary"
              onClick={() => validateCompany(policy)}
              disabled={
                documentType === 'payments_per_day'
                  ? !policy?.financial?.coverage
                  : false
              }
            >
              <Box ml={1}>
                {documentType === 'payment_coupon'
                  ? 'Enviar cupón de pago'
                  : policy?.provider?.company.toLowerCase() == 'galicia'
                  ? 'Descargar póliza'
                  : 'Enviar por email'}
              </Box>
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SendEmail;
